import { Parser, PassingPattern } from "@jugglegym/core/lib/pattern/parser";
import patterns from "./patterns.json";
import { loopFinder } from "@jugglegym/core/lib/loopfinder";
import { HandSequenceChoices } from "@jugglegym/core/lib/handmovement";

interface PlainPattern {
  siteswap: string;
  hands: string;
  name: string;
}

export interface Pattern extends PlainPattern {
  meta: PatternMeta;
}

export interface PatternMeta {
  propCount: number;
  handSequenceName?: string;
  passing: boolean;
  multiplex: boolean;
}

let _patterns: Array<Pattern> | null = null;

export function listPatterns(): Array<Pattern> {
  if (_patterns === null) {
    _patterns = true ? (patterns as Array<Pattern>) : prepPatterns();
  }
  return _patterns;
}

function hasMultiplex(pp: PassingPattern): boolean {
  for (const p of pp.patterns) {
    for (const b of p.beats) {
      for (const bt of b.beatThrows) {
        if (bt.multiplexes.length > 1) {
          return true;
        }
      }
    }
  }
  return false;
}

function prepPatterns(): Array<Pattern> {
  const ret: Array<Pattern> = [];
  const mov2nam: { [key: string]: string } = {};
  HandSequenceChoices.forEach((ch) => {
    mov2nam[ch[1]] = ch[0];
  });
  patterns.forEach((pattern: PlainPattern) => {
    try {
      const p = new Parser(pattern.siteswap).parse();
      const states = loopFinder(p);
      const nam = mov2nam[pattern.hands];
      ret.push({
        ...pattern,
        meta: {
          propCount: states[0].props.nextId,
          handSequenceName: nam,
          passing: p.patterns.length > 1,
          multiplex: hasMultiplex(p),
        },
      });
    } catch (e) {}
  });
  return ret;
}
